import { RseeImportLog } from "./rsee-import-log"

export class RseeImportSummary {
  datacomp: RseeImportLog[] = []
  rsenv: RseeImportLog[] = []
  rset: RseeImportLog[] = []
  unknown: RseeImportLog[] = []
}
